const mutations = {
  brandsmenu(state, brandsmenu) {
    state.brandsmenu = brandsmenu;
  },
  brandmenus(state, brandmenus) {
    state.brandmenus = brandmenus;
  },
  usp(state, usp) {
    state.usp = usp;
  }
};

export default mutations;
